import {
    IAdminToggleBtn,
    IBulkActionDropDown,
    IMainContext,
    StateTypeValues,
} from '@ts/common-types';
import {
    addBulkNegatives,
    bulkActionChangeSubmit,
    handleRevertAction,
    getActiveModule,
    removeFromBuybox,
    updateBuyboxHandler,
    removeBulkNegatives
} from "@ts/utils";
import { ReactComponent as UpdateBidIcon } from "@images/reload_icon.svg";
import { ReactComponent as AddAsNegativeIcon } from "@images/add_as_negative_icon.svg";
import { ReactComponent as PauseIcon } from "@images/pause_icon.svg";
import { ReactComponent as CheckIcon } from "@images/check_icon.svg";
import { ReactComponent as WalletIcon } from "@images/wallet_icon.svg";
import { ReactComponent as PlusIcon } from "@images/plus_icon.svg";
import { ReactComponent as MinusIcon } from "@images/minus_icon.svg";
import { ReactComponent as DaypartingIcon } from "@images/clock_icon.svg";
import { ReactComponent as BulkTaxonomyIcon } from "@images/bulk_taxonomy_icon.svg";
import { ReactComponent as AddNegativeTargetIcon } from "@images/add_negative_target_icon.svg";
import { ReactComponent as SaveActionsIcon } from "@images/save_actions_icon.svg";
import { ReactComponent as BulkTargetActionsIcon } from "@images/bulk_target_actions_icon.svg";
import { ReactComponent as DateChangeIcon } from "@images/date-icon.svg";
import { ReactComponent as AddTagsIcon } from "@images/add-tags.svg";
import { ReactComponent as ArchiveEntity } from "@images/archive_entity.svg";
import Apply1DsMappingIcon from "@images/1ds_logo.jpg";
import { useDispatch, useSelector } from 'react-redux';
import {
    updateActionModal,
    updateAddToExactModalDisp,
    updateBulkActionModal,
    updateBulkTaxonomyDisplay,
    updateCreateCampaignModal,
    updateCampaignConfigModalDisplay,
    updateDayPartingDisplay,
    setAddBulkTagsModalDisplay,
    updateBulkPlacementModalDisplay,
    setBulkProductMappingModalDisplay,
    setBulkKeywordMappingModalDisplay,
    updateApply1DsMappingModalDisplay,
    updateApply1DsKeywordMappingModalDisplay,
    updateBidOrBudgetModalDisplay,
    updateConfirmModalDisplay,
} from "@features/modalSlice";
import { useGetModulesData } from './AllCustomHooks';
import { useContext, useMemo } from 'react';
import { mainContext } from '@ts/constants';
import { MdOutlineRestore } from "react-icons/md";
import { GoPlusCircle } from "react-icons/go";
import { Dropdown, MenuProps } from 'antd';
import { FaPencilAlt, FaBan, FaTrashAlt, FaFileExport, FaPlus } from 'react-icons/fa';
import { deleteDayParting, disableDayParting } from '@/ts/day-parting';
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { BsStopFill } from 'react-icons/bs';

export const useGetBulkActionsMenuData = () => {

    const { isCheckboxSelected } = useContext<IMainContext>(mainContext);
    const enableDayparting = useSelector(
        (state: IAdminToggleBtn) => state.enableDayparting.value
    );
    const enableBuybox = useSelector(
        (state: IAdminToggleBtn) => state.enableBuybox.value
    );
    const { activeModule } = getActiveModule();
    const { featureTypes } = useGetModulesData({ type: "features" });
    const dispatch = useDispatch();
    
    const campaignTaggingFeatureEnabled = useFeatureIsOn("CAMPAIGN_TAGGING_FEATURE") || false;

    const dayPartingMenuItem = (cardData: any) => {
        const items: MenuProps["items"] = [
            {
                label: "Add",
                key: "add-edit-day-parting",
                onClick: () => { cardData.fn() },
                icon: <FaPencilAlt />
            },
            { type: "divider" },
            {
                label: "Disable",
                key: "disable-day-parting",
                onClick: () => {
                    dispatch(updateConfirmModalDisplay({
                        value: true, title: "Do you want to disable day parting?",
                        message: "This will disable all schedules set across the campaigns that are selected!",
                        onConfirm: async () => {
                            await disableDayParting();
                        }
                    }))

                },
                icon: <FaBan style={{ color: "orange" }} />
            },
            { type: "divider" },
            {
                label: "Delete",
                key: "delete-day-parting",
                onClick: () => {
                    dispatch(updateConfirmModalDisplay({
                        value: true, title: "Do you want to delete day Parting",
                        message: "This will remove all schedules set across the campaigns that are selected. This action cannot be reverted!",
                        onConfirm: async () => {
                            await deleteDayParting();
                        }
                    }))

                },
                icon: <FaTrashAlt style={{ color: "red" }} />
            },
        ];

        return (
            <Dropdown menu={{ items }}
                trigger={["hover"]}
                align={{ points: ['tr', 'tl'], offset: [-5, 5] }}
                arrow={{ pointAtCenter: true }} >
                <div className="pa-bulk-action-drop-down-option" >
                    {cardData.icon} &nbsp; {cardData.text}

                </div>
            </Dropdown >)
    }

    const dayPartingItem = {
        text: "Day Parting",
        type: "day-parting",
        status: enableDayparting,
        checkboxSelection: true,
        fn: () => dispatch(updateDayPartingDisplay(true)),
        icon: (
            <span
                className="rounded-circle"
                style={{
                    backgroundColor: "#CEFAF6",
                    padding: "0.5px 5.2px 2px",
                }}
            >
                <DaypartingIcon fill="#19A7CE" width="13" height="13" />
            </span>
        )
    };
    const bulkMenuData: IBulkActionDropDown[] = [
        {
            text: "Update Budget",
            type: "budget",
            operation: "update-budget",
            module: "campaigns",
            checkboxSelection: true,
            status: true,
            fn: () => dispatch(updateBidOrBudgetModalDisplay({ value: true, type: 'budget' })),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#FAF3CE",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <UpdateBidIcon fill="#388EDE" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Update Bid",
            type: "bid",
            operation: "update-bid",
            module: "keywords",
            checkboxSelection: true,
            status: true,
            fn: () => dispatch(updateBidOrBudgetModalDisplay({ value: true, type: 'bid' })),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#FAF3CE",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <UpdateBidIcon fill="#388EDE" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Pause",
            type: "pause",
            operation: "pause",
            module: "keywords",
            checkboxSelection: true,
            status: true,
            fn: () => bulkActionChangeSubmit("pause", activeModule),
            icon: (
                <span
                    className="rounded-circle"
                    id='pause-bulk-action'
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <PauseIcon fill="#D9360E" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Stop",
            type: "stop",
            operation: "archive",
            module: "campaigns",
            checkboxSelection: true,
            status: true,
            fn: () => bulkActionChangeSubmit("archive", activeModule),
            icon: (
                <span
                    className="rounded-circle"
                    id='stop-bulk-action'
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <BsStopFill fill="#D9360E" />
                </span>
            ),
        },
        {
            text: "Enable",
            type: "enable",
            operation: "enable",
            module: "keywords",
            checkboxSelection: true,
            status: true,
            fn: () => bulkActionChangeSubmit("enable", activeModule),
            icon: (
                <span
                    className="rounded-circle"
                    id='enable-bulk-action'
                    style={{
                        backgroundColor: "#CFF8D1",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <CheckIcon fill="#0ED84A" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Archive",
            type: "archive",
            operation: "archive",
            module: "keywords",
            checkboxSelection: true,
            status: true,
            fn: () => bulkActionChangeSubmit("archive", activeModule),
            icon: (
                <span
                    className="rounded-circle"
                    id='archive-bulk-action'
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <ArchiveEntity fill="#D9360E" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Mark as Negative",
            type: "mark-negative",
            operation: "markNegative",
            module: "keywords",
            checkboxSelection: true,
            status: true,
            fn: () => bulkActionChangeSubmit("markNegative", "keywords"),
            icon: (
                <span
                    className="rounded-circle"
                    id='markNegative-bulk-action'
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <AddAsNegativeIcon fill="#D9360E" width="11" height="13" />
                </span>
            ),
        },

        {
            text: "Add to Buybox",
            type: "add-to-buybox",
            operation: "add-to-buybox",
            module: "product-analytics",
            status: enableBuybox,
            checkboxSelection: true,
            fn: updateBuyboxHandler,
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#CDE2F8",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <PlusIcon fill="#388EDE" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Remove Buybox",
            type: "remove-buy-box",
            operation: "remove-buy-box",
            module: "product-analytics",
            status: enableBuybox,
            checkboxSelection: true,
            fn: removeFromBuybox,
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <MinusIcon width="10" height="10" stroke="#D9360E" />
                </span>
            ),
        },
        {
            text: "Enable All",
            type: "enable-all",
            operation: "enabled",
            module: "product-analytics",
            status: true,
            checkboxSelection: true,
            fn: () => bulkActionChangeSubmit(StateTypeValues.ENABLED, activeModule),
            icon: (
                <span
                    className="rounded-circle"
                    id='enabled-bulk-action'
                    style={{
                        backgroundColor: "#CFF8D1",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <CheckIcon fill="#0ED84A" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Pause All",
            type: "pause-all",
            operation: "paused",
            module: "product-analytics",
            status: true,
            checkboxSelection: true,
            fn: () => bulkActionChangeSubmit(StateTypeValues.PAUSED, activeModule),
            icon: (
                <span
                    className="rounded-circle"
                    id='paused-bulk-action'
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <PauseIcon fill="#D9360E" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Create Campaign",
            type: "create-campaign",
            operation: "create-campaign",
            module: "product-analytics",
            status: true,
            checkboxSelection: true,
            fn: () => dispatch(updateCreateCampaignModal(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#D4CEFA",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <WalletIcon fill="#644EEB" width="10" height="10" />
                </span>
            ),
        },
        {
            text: "Bulk Taxonomy",
            type: "bulk-actions",
            status: true,
            fn: () => dispatch(updateBulkTaxonomyDisplay(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#FAF3CE",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <BulkTaxonomyIcon fill="#388EDE" width="13" height="13" />
                </span>
            ),
        },
        {
            ...dayPartingItem,
            element: (dayPartingMenuItem({ text: dayPartingItem.text, fn: dayPartingItem.fn, icon: dayPartingItem.icon }))
        },
        {
            text: "Bulk Target Actions",
            type: "bulk-target-actions",
            checkboxSelection: false,
            status: true,
            fn: () => dispatch(updateBulkActionModal(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#FFE9A0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <BulkTargetActionsIcon
                        fill="#C21010"
                        width="13"
                        height="13"
                    />
                </span>
            ),
        },
        {
            text: "Add Negatives",
            type: "add-negatives",
            fn: addBulkNegatives,
            checkboxSelection: true,
            status: true,
            icon: (
                <span
                    className="rounded-circle"
                    id='add-negatives-bulk-action'
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <AddNegativeTargetIcon
                        fill="#D9360E"
                        width="13"
                        height="13"
                    />
                </span>
            ),
        },
        {
            text: "Remove Negatives",
            type: "remove-negatives",
            fn: removeBulkNegatives,
            checkboxSelection: true,
            status: true,
            icon: (
                <span
                    className="rounded-circle"
                    id='remove-negatives-bulk-action'
                    style={{
                        backgroundColor: "#F6D6D0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <AddNegativeTargetIcon
                        fill="#D9360E"
                        width="13"
                        height="13"
                    />
                </span>
            ),
        },
        {
            text: "Revert Action",
            type: "revert-action",
            fn: handleRevertAction,
            checkboxSelection: true,
            status: true,
            icon: (
                <span
                    className="rounded-circle"
                    id='revert-bulk-action'
                    style={{
                        backgroundColor: "#DAFFFB",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <MdOutlineRestore
                        fill="#4477CE"
                        width="13"
                        height="13"
                    />
                </span>
            ),
        },
        {
            text: "Add As Exact",
            type: "add-as-exact",
            checkboxSelection: false,
            status: true,
            fn: () => dispatch(updateAddToExactModalDisp(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#CDFADB",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <GoPlusCircle fill="#294B29" width="13" height="13" />
                </span>
            ),
        },
        {
            text: "Change End Date",
            type: "date-change",
            checkboxSelection: true,
            status: true,
            fn: () => dispatch(updateCampaignConfigModalDisplay(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#FDE5EC",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <DateChangeIcon fill="#33186B" width="13" height="13" />
                </span>
            ),
        },
        {
            text: "Add Tags",
            type: "tags-add",
            checkboxSelection: true,
            status: campaignTaggingFeatureEnabled,
            fn: () => dispatch(setAddBulkTagsModalDisplay(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#F8EDE3",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <AddTagsIcon fill="#7E6363" width="13" height="13" />
                </span>
            ),
        },
        {
            text: "Save Actions",
            type: "rule",
            checkboxSelection: false,
            status: true,
            fn: () => dispatch(updateActionModal(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#C9EEFF",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <SaveActionsIcon fill="#146C94" width="13" height="13" />
                </span>
            ),
        },
        {
            text: "Placement Change",
            type: "bulk-placement-change",
            checkboxSelection: true,
            status: true,
            fn: () => dispatch(updateBulkPlacementModalDisplay(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#C9EEFF",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <SaveActionsIcon fill="#146C94" width="13" height="13" />
                </span>
            ),
        },
        {
            text: "Add Mapping",
            type: "add-mapping",
            status: true,
            fn: () => {
                if (window.location.pathname.includes("keyword-mapping")) {
                    dispatch(setBulkKeywordMappingModalDisplay(true));
                } else {
                    dispatch(setBulkProductMappingModalDisplay(true));
                }
            },
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#E8F5E9",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <FaPlus fill="#2E7D32" width="13" height="13" />
                </span>
            ),
        },
        {
            text: "Apply 1DS Mapping",
            type: "apply-1ds-mapping",
            status: true,
            fn: () => {
                if (window.location.pathname.includes("keyword-mapping")) {
                    dispatch(updateApply1DsKeywordMappingModalDisplay(true));
                } else {
                    dispatch(updateApply1DsMappingModalDisplay(true));
                }
            },
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#FFF3E0",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <img src={Apply1DsMappingIcon} alt="1DS Mapping" width="13" height="13" />
                </span>
            ),
        },
        {
            text: "Bulk Mapping",
            type: "bulk-mapping",
            status: true,
            fn: () => dispatch(updateBulkTaxonomyDisplay(true)),
            icon: (
                <span
                    className="rounded-circle"
                    style={{
                        backgroundColor: "#E3F2FD",
                        padding: "0.5px 5.2px 2px",
                    }}
                >
                    <FaFileExport fill="#1976D2" width="13" height="13" />
                </span>
            ),
        },
    ];

    //! Logic
    //* isCheckboxSelected = true => show all feature with or without checkbox selection req
    //* isCheckboxSelected = false => show all feature without checkbox selection and they should be there in featureTypes

    return useMemo(() => {
        return featureTypes.length && bulkMenuData.filter((data) =>
            isCheckboxSelected
                ? data.status && featureTypes.includes(data.type)
                : !data.checkboxSelection && featureTypes.includes(data.type)
        );
        // eslint-disable-next-line
    }, [isCheckboxSelected, featureTypes, enableDayparting, enableBuybox, campaignTaggingFeatureEnabled]);

}
